import { Injectable } from '@angular/core';
import { BaseService, GameStatuses, MediaApi, MediaItem } from '@mtgame/core';
import { LeagueRootService } from '@core/services/league-root.service';
import { Observable } from 'rxjs';

const STORE_VIDEO_KEY = 'video';

@Injectable()
export class LeagueLiveService extends BaseService {
  page = 1;
  size = 20;
  total: number;
  leagueId: number;

  get video$(): Observable<MediaItem[]> {
    return this.store.get(STORE_VIDEO_KEY);
  }

  constructor(
    private leagueRootService: LeagueRootService,
    private mediaApi: MediaApi,
  ) {
    super();
  }

  async initialize(): Promise<MediaItem[]> {
    const league = this.leagueRootService.getLeagueModel();
    this.leagueId = league.id;
    this.page = 1;
    return this.loadVideo();
  }

  async loadVideo(): Promise<MediaItem[]> {
    const video = await this.mediaApi.getLeagueMedia(
      this.leagueId,
      this.page,
      this.size,
      {mediaType: 'live_video', sort: 'live', statuses: [GameStatuses.open, GameStatuses.in_progress]}
    );
    if (this.page === 1) {
      this.total = video.total;
      this.store.save(STORE_VIDEO_KEY, video.data);
    } else {
      this.store.appendItems(STORE_VIDEO_KEY, video.data);
    }
    return video.data;
  }
  async loadNextPage(): Promise<MediaItem[]> {
    if (this.page * this.size >= this.total) {
      return Promise.resolve([]);
    }
    this.page++;
    return this.loadVideo();
  }
}
